import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50 whitespace-nowrap">
                皮皮漫画
              </span>
            </div>
            <p className="text-sm text-secondary-300 leading-relaxed">
              皮皮漫画网提供丰富的韩漫在线阅读资源，免费韩国漫画下拉式阅读体验，全集漫画大全持续更新，让您畅游漫画世界。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              漫画分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  全部漫画
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              热门推荐
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/romance" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  恋爱言情
                </Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  奇幻冒险
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  热血动作
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; 2026 皮皮漫画网 mousehole.cn - 韩漫在线阅读 免费韩国漫画下拉式 全集漫画大全
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-secondary-400">关注我们</span>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer">
              <i className="ri-bilibili-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}